import { BRAND_BLACK, BRAND_PURPLE, BRAND_PURPLE_DARK, BRAND_PURPLE_LIGHT } from '../constants/brand';

/** Tripiigo — official purple brand palette */
export const brandColors = {
  navyDarkest: BRAND_BLACK,
  navyDark: '#12081f',
  sidebar: BRAND_BLACK,
  sidebarHover: '#1a1033',
  sidebarActive: BRAND_PURPLE,
  primary: BRAND_PURPLE,
  primaryDark: BRAND_PURPLE_DARK,
  primaryLight: BRAND_PURPLE_LIGHT,
  accent: '#a855f7',
  secondary: '#64748b',
  success: '#22c55e',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: BRAND_PURPLE_LIGHT,
  contentBg: '#f8f7fc',
  cardBg: '#ffffff',
  textMuted: '#64748b',
  textDark: '#0f0a1a',
  border: '#e9e0f7',
  green50: '#f3eeff',
  green100: '#e4d4ff',
  green200: '#c4b5fd',
  gradientPrimary: `linear-gradient(135deg, ${BRAND_PURPLE} 0%, ${BRAND_PURPLE_DARK} 100%)`,
  gradientSoft: 'linear-gradient(135deg, #f3eeff 0%, #e4d4ff 100%)',
  gradientBrand: `linear-gradient(135deg, ${BRAND_PURPLE} 0%, ${BRAND_PURPLE_DARK} 100%)`,
  gradientGreen: `linear-gradient(135deg, ${BRAND_PURPLE_LIGHT} 0%, ${BRAND_PURPLE} 100%)`,
  gradientAuth: `linear-gradient(145deg, ${BRAND_BLACK} 0%, #12081f 45%, #2d1b69 100%)`,
  sidebarSuperAdmin: `linear-gradient(180deg, ${BRAND_BLACK} 0%, #12081f 45%, #2d1b69 100%)`,
  sidebarSuperAdminSolid: '#12081f',
  shadowSm: '0 1px 3px rgba(98,33,214,0.12)',
  shadowMd: '0 4px 20px rgba(98,33,214,0.16)',
  shadowLg: '0 8px 32px rgba(98,33,214,0.22)',
};
